import React from "react";
import VerticalTabs from "../../common/VerticalTabs";
import ProjectRequestForm from "./ProjectRequestForm";

const tabs = [
  { id: "new-project", label: "New Project", component: ProjectRequestForm },
];

const Index: React.FC = () => {
  return <VerticalTabs tabs={tabs} title="Raise Requests" />;
};

export default Index;
